import { useContext } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UsageTrackerContext from 'automation-ui-usage-tracking/UsageTrackerContext';
import { trackEvent } from 'automation-ui-usage-tracking/trackingUtils';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import FeedbackForm from 'automation-ui-enrollment/components/aiAssistant/FeedbackForm';
import { jsx as _jsx } from "react/jsx-runtime";
export default function FeedbackFormForTriggers({
  generationResponse,
  flowId,
  orFilterGroups
}) {
  const {
    usageTracker
  } = useContext(UsageTrackerContext);
  const handleSubmit = (rating, feedback) => {
    trackEvent(usageTracker, Trackables.RATE_GENERATED_ASSET, {
      aiPrompt: orFilterGroups.map(fg => fg.filterInputs.join(' AND ')).join(' OR '),
      assetType: 'AI Generated Workflow Trigger',
      feedback,
      flowId,
      generationResponse: JSON.stringify(generationResponse),
      rating
    });
  };
  return /*#__PURE__*/_jsx(FeedbackForm, {
    heading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-enrollment.aiAssistantFeedbackFooter.ratingButtons.rateTrigger"
    }),
    onSubmit: handleSubmit
  });
}